module.exports = __webpack_public_path__ + "img/bijon.5cb9b14b.png";